import React, { useEffect, useState } from "react";
import { Table, Button, message, Popconfirm } from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import api from "../api";
import ExportadorModal from "../components/ExportadorModal";

const ExportadoresPage = () => {
  const [exportadores, setExportadores] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [editingExportador, setEditingExportador] = useState(null);

  const getExportadores = async () => {
    try {
      setLoading(true);
      const res = await api.get("/exportadores");
      setExportadores(res.data.data || res.data || []);
    } catch (err) {
      message.error("Error al obtener exportadores");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getExportadores();
  }, []);

  const handleDelete = async (id) => {
    try {
      await api.delete(`/exportadores/${id}`);
      message.success("Exportador eliminado exitosamente");
      getExportadores();
    } catch (err) {
      message.error("Error al eliminar exportador");
    }
  };

  const showEditModal = (exportador) => {
    setEditingExportador(exportador);
    setOpen(true);
  };

  const closeAndRefresh = () => {
    setOpen(false);
    setEditingExportador(null);
    getExportadores();
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 16,
          flexWrap: "wrap",
          gap: "16px",
        }}
      >
        <h2 style={{ fontSize: "20px", fontWeight: 600, margin: 0 }}>Lista de Exportadores</h2>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => {
            setEditingExportador(null);
            setOpen(true);
          }}
        >
          Nuevo Exportador
        </Button>
      </div>
      <Table
        dataSource={exportadores}
        loading={loading}
        rowKey="idexportadores"
        columns={[
          { title: "Identificación", dataIndex: "identificacion" },
          { title: "Nombre", dataIndex: "nombre" },
          { title: "Correo", dataIndex: "mail" },
          { title: "Observaciones", dataIndex: "observaciones" },
          {
            title: "Acciones",
            render: (_, record) => (
              <div style={{ display: "flex", gap: "8px" }}>
                <Button
                  type="text"
                  icon={<EditOutlined style={{ color: "blue" }} />}
                  onClick={() => showEditModal(record)}
                />
              </div>
            ),
          },
        ]}
        scroll={{ x: 'max-content' }}
      />

      <ExportadorModal
        open={open}
        exportador={editingExportador}
        onCancel={() => {
          setOpen(false);
          setEditingExportador(null);
        }}
        onSuccess={closeAndRefresh}
      />
    </>
  );
};

export default ExportadoresPage;
